/* Safwa : 3D légère.
   1. Bannière : la photo ondule comme un tissu (WebGL natif, sans bibliothèque), si l'option est cochée sur la bannière.
   2. Photos qui s'inclinent sous la souris.
   Tout est coupé si l'utilisatrice demande moins de mouvement ou économise ses données. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const conn = navigator.connection || {};
  const saveData = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  if (reduce || saveData) return;

  const finePointer = window.matchMedia('(pointer: fine)').matches;

  /* Inclinaison des photos sous la souris (ordinateur seulement) */
  if (finePointer) {
    document.querySelectorAll('[data-tilt]').forEach((el) => {
      el.style.transition = 'transform .6s cubic-bezier(.2,.7,.2,1)';
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = `perspective(1000px) rotateY(${x * 5}deg) rotateX(${-y * 5}deg)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  }

  /* 1. Bannière : tissu en WebGL */
  const mem = navigator.deviceMemory || 4;
  if (mem < 2) return;
  document.querySelectorAll('[data-hero][data-fabric]').forEach((hero) => {
    const img = hero.querySelector('img.hero__img');
    if (!img) return;
    const start = () => fabric(hero, img);
    if (img.complete && img.naturalWidth) start(); else img.addEventListener('load', start, { once: true });
  });

  function fabric(hero, img) {
    const media = img.parentElement;
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl', { alpha: false, antialias: false, premultipliedAlpha: false });
    if (!gl) return;

    const vs = 'attribute vec2 p;varying vec2 v;void main(){v=p*.5+.5;gl_Position=vec4(p,0.,1.);}';
    const fs = [
      'precision mediump float;',
      'varying vec2 v;uniform sampler2D t;uniform float time;uniform vec2 cover;uniform vec2 m;',
      'float h(vec2 q){return sin(q.x*6.+time*.7+sin(q.y*3.+time*.4))*.5+sin(q.y*9.-time*.5+q.x*2.)*.25;}',
      'void main(){',
      ' vec2 q=v;',
      ' float e=.002;',
      ' float hx=h(q+vec2(e,0.))-h(q-vec2(e,0.));',
      ' float hy=h(q+vec2(0.,e))-h(q-vec2(0.,e));',
      ' vec3 n=normalize(vec3(-hx*.9,-hy*.9,1.));',
      ' vec2 uv=(q-.5)*cover+.5;',
      ' uv+=n.xy*.012+(m-.5)*.012;',
      ' uv.y=1.-uv.y;',
      ' vec3 c=texture2D(t,clamp(uv,0.,1.)).rgb;',
      ' vec3 l=normalize(vec3(-.4+m.x*.3,.5,.9));',
      ' float d=dot(n,l);',
      ' c*=.9+d*.14;',
      ' gl_FragColor=vec4(c,1.);',
      '}'
    ].join('');

    const sh = (type, src) => { const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null; };
    const a = sh(gl.VERTEX_SHADER, vs), b = sh(gl.FRAGMENT_SHADER, fs);
    if (!a || !b) return;
    const prog = gl.createProgram();
    gl.attachShader(prog, a); gl.attachShader(prog, b); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
    gl.useProgram(prog);

    const buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(prog, 'p');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    const tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

    /* Texture : on recharge l'image en CORS ; si le navigateur refuse, la photo fixe reste affichée */
    const src = new Image();
    src.crossOrigin = 'anonymous';
    src.onload = () => {
      try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, src); } catch (err) { return; }
      media.appendChild(canvas);
      resize();
      requestAnimationFrame(() => canvas.classList.add('is-ready'));
      loop();
    };
    src.src = img.currentSrc || img.src;

    const uTime = gl.getUniformLocation(prog, 'time');
    const uCover = gl.getUniformLocation(prog, 'cover');
    const uM = gl.getUniformLocation(prog, 'm');
    let mx = .5, my = .5, tx = .5, ty = .5;
    hero.addEventListener('pointermove', (e) => { const r = hero.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width; ty = (e.clientY - r.top) / r.height; });

    function resize() {
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      const w = media.clientWidth, h = media.clientHeight;
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      gl.viewport(0, 0, canvas.width, canvas.height);
      /* équivalent de object-fit: cover */
      const ra = w / h, ri = src.naturalWidth / src.naturalHeight;
      gl.uniform2f(uCover, ra > ri ? 1 : ra / ri, ra > ri ? ri / ra : 1);
    }
    window.addEventListener('resize', resize, { passive: true });

    let visible = true, raf = 0;
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible && !raf) loop(); }).observe(hero);
    document.addEventListener('visibilitychange', () => { if (!document.hidden && visible && !raf) loop(); });

    const t0 = performance.now();
    function loop() {
      if (!visible || document.hidden) { raf = 0; return; }
      mx += (tx - mx) * .05; my += (ty - my) * .05;
      gl.uniform1f(uTime, (performance.now() - t0) / 1000);
      gl.uniform2f(uM, mx, my);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      raf = requestAnimationFrame(loop);
    }
  }
})();
